import { initialState } from "./order-state";
import { ActionsTypes, RESET_ORDER, SET_ORDER } from "./order-actions";
import { OrderState } from "./order-state";

export default (state: OrderState = initialState, action: ActionsTypes): OrderState => {
    switch (action.type) {
        case SET_ORDER: {
            return {
                ...state,
                ...action.payload
            };
        }
        case RESET_ORDER: {
            return initialState;
        }
        default:
            return state;
    }
};